module.exports = __webpack_public_path__ + "static/media/close-ico.43b81428.svg";